import { Component, Inject, ViewChild } from '@angular/core';
import { SabisButton2Component, SabisComboBox2Component, SabisInput2Component, SabisNgxDialogComponent } from 'sabis-components2';
import { CardViewComponent } from 'src/app/shared/card-view/card-view.component';
import { FormsModule, NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { AppLoaderService } from '../../../../@theme/shared/services/app-loader/app-loader.service';
import { AppNotificationsService } from '../../../../core/notifications/app-notifications.service';
import { StepAction } from '../../../../settings/recruitment-steps/recruitment-steps.service';
import { EmailComponent } from '../../../../shared/email/email.component';
import { EmailEditorDTO, EmptyEmailEditorDTO } from '../../../../shared/email/models/api-models';
import { FeedbackRequestEditorInitDTO, FeedbackRequestsService, SaveFeedbackRequestCDTO } from '../feedback-requests.service';
import { LookupItem } from 'src/app/shared/lookup/models';
import { toLookupItems } from 'src/app/shared/api-common-models';

@Component({
  selector: 'sca-feedback-request-editor',
  templateUrl: './feedback-request-editor.component.html',
  styleUrls: ['./feedback-request-editor.component.scss'],
  imports: [
    FormsModule,
    EmailComponent,
    CardViewComponent,
    SabisInput2Component,
    SabisButton2Component,
    SabisNgxDialogComponent,
    SabisComboBox2Component,
  ]
})
export class FeedbackRequestEditorComponent {
  @ViewChild('f') formViewChild!: NgForm;

  private _feedbackRequestId: number | null = null;
  public title: string = 'Test Component';
  public isLoading: boolean = false;
  public isDisabled: boolean = false;
  public isSaving: boolean = false;

  public userEmails: RefereeViewModel[] = [];
  // allowed email template ids set in settings > selection steps > email templates
  public allowedEmailTemplateIds: number[] = [];
  // hide Attach documents button from Email editor if step is FeedbackRequest
  public canAttachDocuments: boolean = false;
  // show/hide email CC from email form
  public showEmailCC: boolean = false;
  @ViewChild('emailForm') emailForm!: EmailComponent;

  constructor(
    public dialogRef: MatDialogRef<FeedbackRequestEditorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FeedbackRequestDialogData,
    private _appNotifications: AppNotificationsService,
    private _appLoader: AppLoaderService,
    private _feedbackRequestsService: FeedbackRequestsService,

  ) {
    this.title = 'Feedback Request';
    this.emptyEmail();
    //this.email.emailTemplateId = this.data.defaultEmailTemplateId;
    this.canAttachDocuments = this.data.canAttachDocuments;
  }
  public userEmail: string = "";

  public email: EmailEditorDTO = EmptyEmailEditorDTO;

  // Feedback forms
  public selectedFeedbackFormId: number = 0;
  public feedbackForms: LookupItem<any>[] = [];

  ngOnInit(): void {
    this._appLoader.showLoading();
    this.isLoading = true;
    this._feedbackRequestsService.getFeedbackRequestEditorInitData(this.data.applicationId, this.data.selectionStepId, StepAction.Start).subscribe(r => {
      // get allowed email template ids set up in Settings > Selection Steps > Email Templates
      this.allowedEmailTemplateIds = r.allowedEmailTemplatesIds;
      this.showEmailCC = r.showEmailCC;
      this._appLoader.hideLoading();
      this.isLoading = false;
    })

    //get the reference check feedback forms if there are more than 1
    this._feedbackRequestsService.getStepFeedbackFormTemplates(this.data.selectionStepId, this.data.applicationId).subscribe(r => {
      this.setInitialData(r);
    });
  }

  private setInitialData(r: FeedbackRequestEditorInitDTO): void {
    this.feedbackForms = toLookupItems(r.feedbackForms);
    if (this.feedbackForms.length == 1) {
      this.selectedFeedbackFormId = this.feedbackForms[0].itemId;
    }
  }

  private toggleDisabled(): void {
    this.isDisabled = this.isSaving || this.isLoading;
  }

  public onCancelClick(): void {
    this.dialogRef.close(false);
  }

  public onSaveClick(): void {
    this.save();
  }

  private save(): void {
    if (this.isSaving) {
      return;
    }

    let isValid = this.validateForSave();
    if (!isValid) {
      this._appNotifications.showInvalidEntriesMessage();
      return;
    }

    this.isSaving = true;
    this.toggleDisabled();
    this._appLoader.showSaving();
    let command: SaveFeedbackRequestCDTO = {
      userEmail: this.userEmail,
      selectionStepId: this.data.selectionStepId,
      email: null,
      isCollectFeedback: false, // for reference check step, feedback is not collected from interviewer
      templateVersionId: this.selectedFeedbackFormId  // templateVersionId is sent null here since for reference check step, it is set in Selection Step screen
    };

    command.email = {
      body: this.email.body,
      emailTemplateId: this.email.emailTemplateId!,
      fromEmail: this.email.fromEmail,
      priorityId: this.email.priorityId!,
      subject: this.email.subject,
      toEmail: this.email.toEmail,
      ccEmail: this.email.ccEmail,
      scheduledDate: this.email.isScheduledForLater == false ? undefined : this.email.scheduledDate,
      isScheduledForLater: this.email.isScheduledForLater,
      attachments: this.email.attachments
    }

    let request = this._feedbackRequestsService.addReferenceCheck(this.data.applicationId, command)

    request.pipe(
      finalize(() => {
        this.isSaving = false;
        this.toggleDisabled();
        this._appLoader.hideSaving();
      })
    ).subscribe({
      next: (r) => {
        this._feedbackRequestId = r;
        this._appNotifications.notifySaveSucceeded();
        this.dialogRef.close(true);
      },
      error: () => {
        /*        this._appNotifications.notifySaveFailed();*/
      }
    });
  }

  private emptyEmail(): void {
    this.email = { body: "", emailTemplateId: null, fromEmail: "", priorityId: null, subject: "", toEmail: "", ccEmail: "", scheduledDate: undefined, scheduledTime: undefined, isScheduledForLater: false, attachments: [] };
  }

  private updateRefereesSubTitle(items: RefereeViewModel[]): void {
    let count = 1;
    items.forEach(r => {
      r.itemSubTitle = "Email " + count++;
    });
  }

  private fillToEmail(item: string): void {

    this.email.toEmail = item;
  }

  public onRefereeChanged(): void {
    this.fillToEmail(this.userEmail);
  }

  /**
* return true if valid
* @returns
*/
  private validateForSave(): boolean {
    this.formViewChild.form.markAllAsTouched();

    // validate email
    if (this.emailForm && !this.emailForm.validate()) {
      return false;
    }

    if (this.userEmail == "") {
      return false;
    }

    if (this.selectedFeedbackFormId == 0) {
      return false;
    }

    return true;
  }
}
export interface FeedbackRequestDialogData {
  applicationId: number;
  selectionStepId: number;
  defaultEmailTemplateId: number | null;
  canAttachDocuments: boolean;
  showRecipient: boolean;
}

/** view model used for referees */
export interface RefereeViewModel {

  email: string;
  itemSubTitle: string;
}

